<template>
    <div class="homePage" style="width: 100%; height: 100%">
        <!-- 图书分类---轮播图 -->
        <div class="banner_box wrap" style="margin-top: 20px">
            <div class="sub_nav" id="classificAction">
                <h5>图书分类</h5>
                <ul>
                    <li v-for="(item, index) in xuekeBook" :key="index" >
                        <a class="border_r" @click="goxueke(index, item.typeLevel, item.typeCode)" style="cursor: pointer;">{{ item.typeName }}</a>
                    </li>
                    <!-- <li class="lv_bg" @click="goxueke"><a href="#">...</a></li> -->
                    <div class="clear"></div>
                </ul>
            </div>
            <div class="container">
                <div class="swiper-container swiper  book_lr swiper-container-horizontal" id="swiperRecomend">
                    <el-carousel :interval="4000" type="card" height="320px" >
                        <el-carousel-item v-for="(item, index) in bannerListArr" :key="index">
                            <h3 class="medium" @click="toDetail(item)" v-if="item.ebookId!=''">
                                <img class="img" :src="item.bannerImage" alt="" :onerror="pic">
                            </h3>
                            <h3 class="medium" v-else>
                                <img class="img" :src="item.bannerImage" alt="" :onerror="pic">
                            </h3>
                        </el-carousel-item>
                        <!-- <el-carousel-item >
                            <h3 class="medium">
                                <img class="img" src="../assets/images/6d07d9079872dd7317f9c29819f1bfba.png" alt="" :onerror="pic">
                            </h3>
                        </el-carousel-item>
                        <el-carousel-item >
                            <h3 class="medium">
                                <img class="img" src="../assets/images//50103ab66b92a51c3bad7ed3ed917855.png" alt="" :onerror="pic">
                            </h3>
                        </el-carousel-item>
                        <el-carousel-item >
                            <h3 class="medium">
                                <img class="img" src="../assets/images/ddf7c449a9daf3a93611b2ff8c2cfc03.png" alt="" :onerror="pic">
                            </h3>
                        </el-carousel-item> -->
                    </el-carousel>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <!-- 好书推荐---排行榜 -->
        <div class="wrap common">
            <div class="new_books">
                <div class="tit">
                    <h3>{{ columnListData[0].columnName }}</h3>
                    <!-- <a class="btn hand" id="batch">换一批</a> -->
                </div>
                <div id="booknews" >
                    <div class="books" v-for="(item,index) in columnListData[0].baseDataInfoList" :key="index"> 
                        <div class="book_img">
                            <img :src="item.coverImage" @click="goBookDetails(item)" :onerror="pic">
                        </div>
                        <div class="cont" >
                            <div class="hei">
                                <h3 @click="goBookDetails(item)" style="cursor: pointer;">{{item.bookName}}</h3>
                                <span>{{item.author}}</span>
                            </div>
                            <p>{{item.bookSummary}}</p>
                            <a class="btn btn_white hand tryread2 kzreader" @click="read(item)">{{item.collection == 1 ? '阅读全文' : '试读'}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="reading x_read">
                <div class="tit_but" id="titBut">
                    <span v-bind:class="{ current: byweeks}"  @click="week">
                        <a class="x_btn" href="javascript:;">周排行</a>
                    </span>
                    <span v-bind:class="{ current: !byweeks}"  @click="month">
                        <a class="x_btn" href="javascript:;">月排行</a>
                    </span>
                </div>
                <div class="cont">
                    <ul id="readRank" :key="byweekNav" v-if="byweeks">
                        <li v-for="(item,index) in weekArr" :key="index"  v-bind:class="{ current1: item.active}">
                            <em class="point"></em>
                            <p  @click="goBookDetails(item)">
                                <i class="num">{{index + 1}}</i>
                                <span >
                                    <a class="img_box readRank" v-show="item.active">
                                        <img :src="item.coverImage" alt="" :onerror="pic">
                                    </a>
                                    <a class="font">
                                        <em class="readRank hand" v-on:mouseenter ="weekClassload(index)">{{item.bookName}}</em>
                                        <i class="author" v-on:mouseenter ="weekClassload(index)">{{item.author}}</i>
                                    </a>
                                </span>
                            </p>
                        </li>
                    </ul>
                    <ul id="readRank" :key="bymonthNav" v-if="bymonths">
                        <li v-for="(item,index) in monthArr" :key="index"  v-bind:class="{ current1: item.active}">
                            <em class="point"></em>
                            <p @click="goBookDetails(item)">
                                <i class="num">{{index + 1}}</i>
                                <span >
                                    <a href="javascript:;" class="img_box readRank" v-show="item.active">
                                        <img :src="item.coverImage" alt="" :onerror="pic">
                                    </a>
                                    <a href="javascript:;" class="font">
                                        <em class="readRank" v-on:mouseenter ="monthClassload(index)">{{item.bookName}}</em>
                                        <i class="author" v-on:mouseenter ="monthClassload(index)">{{item.author}}</i>
                                    </a>
                                </span>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <!---->
        <div class="wrap common" v-for="(list, nums) in columnListData" :key="nums" v-if="nums>0 && list.baseDataInfoList.length>0">
            <div class="new_books x_new_books">
                <div class="tit tits">
                    <h3>{{ list.columnName }}</h3>
                    <p data-type="2">
                        <a class="">
                            <router-link :to="{path: '/Home/libraryResources'}">更多</router-link>
                        </a>
                    </p>
                </div>
                <div class="book_list x_book_list" id="two" >
                    <ul id="popularSelling" v-show="tab ==0" :key="twoTab">
                        <li v-for="(item, index) in list.baseDataInfoList" :key="index">
                            <p class="bookImgs" :key="imgClassloadActive">
                                <a href="javascript:;" @click="goBookDetails(item)">
                                    <img :src="item.coverImage" alt="" :onerror="pic">
                                </a>
                            </p>
                            <a href="javascript:;" class="readRank" @click="goBookDetails(item)">{{item.bookName}}</a>
                            <span @click="goBookDetails(item)">{{item.author}}</span>
                            <div class="details fir_details" @click="goBookDetails(item)">
                                <h3 class="readRank hand">{{item.bookName}}</h3>
                                <em >{{item.author}}</em>
                                <em>{{ item.publisherName }}</em>
                                <em>{{ item.pubTime }}</em>
                                <p class="readRank hand">
                                    {{ item.bookSummary }}
                                </p>
                                <p style="display: flex;justify-content: center;margin-top: 20px;">
                                    <span><a class="classifyReade hand" @click="read(item)">{{item.collection == 1 ? '阅读' : '试读'}}</a></span>
                                    <span v-if="config[2].type == 3 && config[2].enableStatus == 1">
                                        <el-button style="padding:0px 5px;" class="bule classifyShelf" @click="addBookToShelf(item.pkid, item.source)" v-if="bookshelfId.indexOf(item.pkid) < 0">加入书架</el-button>
                                        <el-button style="padding:0px 5px;" class="gray classifyShelf" disabled v-else>已加入书架</el-button>
                                    </span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <!-- 畅销好书 -->
        <!-- <div class="wrap common">
            <div class="new_books x_new_books">
                <div class="tit tits">
                    <h3>畅销好书</h3>
                    <p data-type="3">
                        <a class="">
                            <router-link :to="{path: '/Home/libraryResources'}">更多</router-link>
                        </a>
                    </p>
                </div>
                <div class="book_list x_book_list">
                    <ul id="subject" v-show="Tab ==0" :key="threeTab">
                        <li v-for="(item,index) in threeimageArr" :key="index" >
                            <p class="bookImgs" v-on:mouseleave = "newBookRemove(index)">
                                <a href="javascript:;" @click="goBookDetails(item)" v-on:mouseenter = "newBookClassload(index)" :key="imgClassloadActive">
                                    <img :src="item.coverImage" alt=""  :onerror="pic">
                                </a>
                            </p>
                            <a href="javascript:;" @click="goBookDetails(item)">{{item.bookName}}</a>
                            <span @click="goBookDetails(item)">{{item.author}}</span>
                            <div class="details fir_details"  v-show="item.active" >
                                <h3 class="readRank hand" @click="goBookDetails(item)">{{item.bookName}}</h3>
                                <em>{{item.author}}</em>
                                <em>{{ item.publisherName }}</em>
                                <em>{{ item.pubTime }}</em>
                                <p class="readRank hand" @click="goBookDetails(item)">
                                    {{ item.bookSummary }}
                                </p>
                                <span style="display: flex;margin-top: 20px;">
                                    <a class="classifyReade hand" @click="read(item)">试读</a>
                                    <el-button  style="width: 100px;padding:0" class="bule classifyShelf" :disabled="item.addBookDisabled" @click="addBookshelf(item.pkid)">{{ item.addBook }}</el-button>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="clear"></div>
        </div> -->
        <!-- 名家大作 -->
        <!-- <div class="wrap common" id="common">
            <div id="UIFrame_472887" style="display: block;">
                <div class="new_books x_new_books x_book_lr">
                    <div class="tit">
                        <h3>名家大作</h3>
                    </div>
                    <div class=" book_list book_lr " id="swiperRecomend">
                        <div class="" id="recomendList" >
                            <div v-for="(item,index) in fourimageArr" :key="index" >
                                <ul style="display:flex;overflow: hidden;">
                                    <li v-show="flag1?index<6:true">
                                        <p @click="goBookDetails(item)">
                                            <a href="javascript:;">
                                                <img :src="item.coverImage" alt="" :onerror="pic">
                                            </a>
                                            <a href="javascript:;" class="ellipsis">{{item.bookName}}</a>
                                            <span class="ellipsis">{{item.author}}</span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div> -->
    </div>
</template>

<script>
import Axios from "@/api/diyaxios";
import Header from "../components/Header.vue";
import Login from "../views/Login/Login";//登录
import Register from "../views/Login/Register";//登录
import LogReg from "../views/LogReg.vue";//登录
import {  getClassifyData } from "@/api/colinfo";//首页数据
import { ids, bannerlist, sourceType } from "@/api/ebook";//处理数据
import {  byweek, bymonth, authCheck, addId} from "@/api/visitlog";//周月排行榜
import { swiper, swiperSlide } from "vue-awesome-swiper";//轮播图
import "swiper/swiper.css";//轮播图
import {  queryBycondition } from "@/api/typeInfo";//图书分类
import {  bookshelfList ,addBookshelf} from "../api/bookshelf.js";//查询书架数据
import { getUserInfo, getItem } from "@/common/utils/localStorage.js";
import popup from "@/common/plugin/dialog/index";
import addShelf from '../components/addShelf/index.vue';
import{ subjectType } from '@/api/statistics'

export default {
    name: "HomePage",
    data() {
        return {
            userInfo: getUserInfo(),
            // 图书分类
            //好书推荐
            byweekList:[],//周排行榜
            byweeks: true,//周排行显示
            byweekNav: true,//周排行榜key
            weekpkid: [],
            weekpkids:"",
            weekArr: [],
            bymonthList:[],//月排行榜
            bymonths: false,//月排行显示
            bymonthNav: false,//月排行榜key
            monthpkid: [],
            monthpkids:"",
            monthArr: [],
            imgClassloadActive: true,
            bannerListArr:[{
                ebookId:'',
                bannerImage: require('../assets/images/6d07d9079872dd7317f9c29819f1bfba.png'),
            },{
                ebookId:'',
                bannerImage: require('../assets/images//50103ab66b92a51c3bad7ed3ed917855.png'),
            },{
                ebookId:'',
                bannerImage: require('../assets/images/ddf7c449a9daf3a93611b2ff8c2cfc03.png'),
            }],
            columnListData:[{columnName:''}],
            oneList: [],
            onepkids: "",
            onepkid: [],
            oneimageArr: [],
            oneimgArr: [],
            // 网络文学
            twoList:[],
            twopkids:"",
            twopkid:[],
            twoimageArr: [],
            tab:0,
            twoTab: false,
            // 畅销好书
            threeList:[],
            threepkids: "",
            threepkid:[],
            threeimageArr: [],
            Tab: 0,
            threeTab: false,
            // 名家大作
            fourList:[],
            fourpkids:"",
            fourpkid:[],
            fourimageArr: [],
            imgArr: [],
            swiperOptions: {
                width: 1200,//
                loop: true, //
            },//名家大作轮播图
            switchArr: [],
            pic: 'this.src = "' + require('../assets/images/no_cover3.png') + '"' ,
            xuekeBook: [],//学科分类
            xueke: [],
            flag: false,
            infoList: [],//书架数据
            ebookIds: [],//书架id
            ebookIdes: [],
            filterUnique: "",
            addBook: "加入书架",
            addBookDisabled: false,
            bookshelf: [],
            bookshelfId: [],
            flag1: true,
            resData: "",
            bibGid: "",
            pubName: "",//出版社名字
            parentSubjectCode: "",//学科分类号
            classifyCode: "",//中图法分类号
            fileType1: "",
            config:[]
        };
    },
    components: {
        Header,
        Register,
        LogReg,
        Login,
        swiper,
        swiperSlide
    },
    created() {
        let vm = this;
    },
    mounted() {
        let vm = this; 
        vm.getAuthCheck();
    },
    methods: {
        getAuthCheck() {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                "visitType": 1,
                "visitUrl": "/#/home/homePage",
                "visitFunc": "",
            };
            authCheck(obj).then((res) => {
                vm.resData = res.code
                if(vm.resData != 200) {
                    vm.$router.push({name:"Login"})
                } else {
                    vm.getBannerlist();//banner列表
                    vm.getBookClassify(); //图书分类
                    vm.getClassifyList(); //栏目分类
                    vm.getShelfbooklist();
                    // vm.oneContext();
                    // vm.twoContext();
                    // vm.threeContext();
                    // vm.fourContext();
                    vm.byweek();
                }
            }).catch((err) => {
                if(err != 200) {
                    vm.$router.push({name:"Login"})
                }
            })
        },
        getBannerlist(){
            let vm = this;
            bannerlist({
                orgId: vm.userInfo.orgId,
            }).then(res=>{
                if(res.status){
                    if(res.data.length > 0){
                        vm.bannerListArr = res.data;
                    }
                }
            }).catch(err => {

            });
        },
        // 图书分类
        getBookClassify() {
            let vm = this,
                obj = {
                    // isLeaf: 0,
                    typeLevel: 1,
                    visitType: 2,
                    visitUrl: location.href,
                    visitFunc: '查询'
                };
                subjectType(obj).then((res) => {
                vm.xuekeBook = res.data;
                // vm.xuekeBook.splice(0,1)
            });
        },
        //获取分类对应的书列表
        getClassifyList(){
            let vm = this,
                obj = {
                    showStatus:1,
                    columnStatus:1,
                    // dataSource:1, //1-平台电子书，2-本馆电子书，
                    deviceType:1,
                    visitType: 2,
                    visitUrl: location.href,
                    visitFunc: '查询',
                    orgId: getUserInfo().orgId,
                };
            // vm.columnListData = [{columnName:''}];
            getClassifyData(obj).then((res) => {
                if(res.status){
                    let Base64 = require('js-base64').Base64;
                    res.data.forEach((list, index) => {
                        if(list.baseDataInfoList){
                            list.baseDataInfoList.map((ele, i) => {
                                if(ele.coverImage == null) {
                                    ele.coverImage = vm.pic;
                                } else {
                                    ele.coverImage = Base64.decode(ele.coverImage);
                                }
                            });
                        }
                        // vm.columnListData.push(list);
                    });
                    vm.columnListData = res.data;
                    vm.config = JSON.parse(getItem('config'));
                }
            }).catch(err=>{

            });
        },
        // 加入书架
        addBookToShelf(pkid, source) {
            let vm = this,
                userInfo = getUserInfo(),
                obj = {
                    // "ebookType": 0,
                    "ebookId": pkid,
                    "pageSize": 100000,
                    "creatorId": userInfo.pkid,
                    // "userId": userInfo.pkid,
                    "visitType": 2,
                    "visitUrl": location.href,
                    "visitFunc": "",
                };
            bookshelfList(obj).then((res) => {
                if (res.code == 201) {              
                    vm.add_shelf = popup('<add-shelf :ebooksource="ebookType" :ebookid="ebookId" @close="close" @ok="submit" />',{
                        option:{
                            title:'加入书架',
                            width:'450px'
                        },
                        popup:{
                            data(){
                                return{
                                    ebookType: source,
                                    ebookId: pkid
                                }
                            },
                            components:{
                                addShelf
                            },
                            methods:{
                                submit(data){
                                    if (data.code == 200) {
                                        vm.$message({
                                            message: "您已成功加入书架！",
                                            type: "success"
                                        });
                                        vm.getShelfbooklist();
                                    }
                                    vm.add_shelf.hide();
                                },
                                close(data){
                                    vm.add_shelf.hide();
                                }
                            }
                        }
                    })
                    vm.add_shelf.show();
                }else if(res.code == 200) {
                    this.$message({
                        message: "该书已加入购物车",
                        type: "error"
                    })
                }
            });
        },
         // 查询书架数据
         getShelfbooklist() {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                "ebookType": 0,
                // "pageNum": vm.pageNum,
                "pageSize": 100000,
                "creatorId": userInfo.pkid,
                // "userId": userInfo.pkid,
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            bookshelfList(obj).then((res) => {
               vm.bookshelf = res.data.list
               if(vm.bookshelf != null) {
                   vm.bookshelf.forEach(item => {
                       vm.bookshelfId.push(item.ebookId)
                    })
                } else {
                }
            });
        },

        //去学科分类页
        goxueke(index, typeLevel, typeCode) {
            let vm = this,
                obj = {
                    active: 0,
                    index: index,
                    typeLevel: typeLevel,
                    typeCode: typeCode
                };
            vm.$router.push({path:"/home/libraryResources", query: {obj: JSON.stringify(obj)}});
        },
        //周排行榜
        weekClassload(index) {
            this.weekArr.map(item => item.active = false)
            this.weekArr[index].active = true;
            this.byweekNav = !this.byweekNav;
        },
        // 月排行榜
        monthClassload(index) {
            this.monthArr.map(item => item.active = false)
            this.monthArr[index].active = true;
            this.bymonthNav = !this.bymonthNav;
        },
        // 网络文学图片
        imgClassload(item,index) {
            this.twoimageArr.map(item => item.active = false)
            this.twoimageArr[index].active = true;
            this.imgClassloadActive = !this.imgClassloadActive
            this.twoTab = !this.twoTab;
            // this.twoContext()
        },
        imgRemove(index) {
            this.twoimageArr.map(item => item.active = false)
            this.twoimageArr[index].active = false;
            this.imgClassloadActive = !this.imgClassloadActive
        },
        // 网络文学
        twoContext() {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                columnName:"网络文学",
                pageSize: 12,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
                orgId: userInfo.orgId,
            };
            querybyconditon(obj).then((res) => {
                vm.twoList = res.data[0].homepageColBooks.list;
                vm.twoList.map(item => {
                    // console.log(item);
                    vm.twopkid.push(item.ebookId)
                    item.addBook = "加入书架"
                    vm.filterUnique = item.ebookId
                    this.twopkids = vm.twopkid.join(",")
                    
                })
                // vm.twoids(this.twopkids)
            });
        },
        twoids(twopkids) {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                pkids: twopkids,
                pageSize: 12,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
            };
            ids(obj).then((res) => {
                if(res.code == '200') {
                    vm.twoimageArr = res.data.list;
                    vm.twoimageArr.forEach(item => {
                        
                        item.active = false;
                        item.addBook = "加入书架"
                        if(vm.bookshelfId != null) {
                            this.bookshelfId.map((item1,index1)=>{//再判断有相同项的状态为1
                                if(item.pkid == item1){
                                    item.addBookDisabled = true
                                    item.addBook = "已加入书架"
                                }
                            })
                        } else {
                        }
                    })
                    let Base64 = require('js-base64').Base64
                    vm.twoimageArr.map((item) => {
                        vm.bibGid = item.bibGid
                        vm.pubName = item.pubName
                        vm.parentSubjectCode = item.parentSubjectCode
                        // vm.classifyCode = item.classifyCode
                        vm.ebookIdes.push(item.pkid)
                        if(item.coverImage == null) {
                            item.coverImage = vm.pic
                        } else {
                            item.coverImage = Base64.decode(item.coverImage);
                        }
                    })
                    
                }
            })
        },
        // 网络文学图片导航栏
        menu(key) {
            this.tab = key
        },
        // 畅销好书
        newBookClassload(index) {
            this.threeimageArr.map(item => item.active = false)
            this.threeimageArr[index].active = true;
            this.imgClassloadActive = !this.imgClassloadActive
            this.threeTab = !this.threeTab;
        },
        newBookRemove(index) {
            this.threeimageArr[index].active = false;
            this.imgClassloadActive = !this.imgClassloadActive
        },
         // 畅销好书
        threeContext() {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                columnName:"畅销好书",
                pageSize: 12,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
                orgId: userInfo.orgId,
            };
            querybyconditon(obj).then((res) => {
                vm.threeList = res.data;
                vm.threeList[0].homepageColBooks.list.forEach(item => {
                    vm.threepkid.push(item.ebookId)
                })
                this.threepkids = vm.threepkid.join(",")
                // vm.threeids(this.threepkids)
            });
        },
        threeids(threepkids) {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                pkids: threepkids,
                pageSize: 12,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
            };
            ids(obj).then((res) => {
                if(res.code == '200') {
                    vm.threeimageArr = res.data.list;
                    vm.threeimageArr.forEach(item => {                        
                        item.active = false;
                        item.addBook = "加入书架"
                        if(vm.bookshelfId != null) {
                            this.bookshelfId.map((item1,index1)=>{//再判断有相同项的状态为1
                                if (item.pkid == item1) {
                                    item.addBookDisabled = true
                                    item.addBook = "已加入书架"
                                }
                            })
                        } else {

                        }
                    })
                    let Base64 = require('js-base64').Base64
                    vm.threeimageArr.map((item) => {
                        vm.bibGid = item.bibGid
                        vm.pubName = item.pubName
                        vm.parentSubjectCode = item.parentSubjectCode
                        // vm.classifyCode = item.classifyCode
                        if(item.coverImage == null) {
                            item.coverImage = vm.pic
                        } else {
                            item.coverImage = Base64.decode(item.coverImage);
                        }
                    })
                    vm.fourContext();
                }
            })
        },
        twoMenu(key) {
            this.Tab = key
        },
        //好书推荐
        oneContext() {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                columnName:"好书推荐",
                pageNum: 1,
                pageSize: 4,
                orgId: userInfo.orgId,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
            };
            querybyconditon(obj).then((res) => {
                vm.oneList = res.data;
                vm.oneList[0].homepageColBooks.list.forEach(item => {
                    vm.onepkid.push(item.ebookId)
                })
                this.onepkids = vm.onepkid.join(",")
                // vm.oneids(this.onepkids)
            });
        },
        oneids(onepkids) {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                pkids: onepkids,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
                pageNum: 1,
                pageSize: 4,
            };
            ids(obj).then((res) => {
                if(res.code == '200') {
                    vm.oneimageArr = res.data.list;
                    let Base64 = require('js-base64').Base64
                    vm.oneimageArr.map((item) => {
                        
                        vm.bibGid = item.bibGid
                        vm.pubName = item.pubName
                        vm.parentSubjectCode = item.parentSubjectCode
                        // vm.classifyCode = item.classifyCode
                        if(item.coverImage == null) {
                            item.coverImage = vm.pic
                        } else {
                            item.coverImage = Base64.decode(item.coverImage);
                        }
                    })
                }
            })
        },
        // 名家大作
        fourContext() {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                columnName:"名家大作",
                orgId: userInfo.orgId,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
            };
            querybyconditon(obj).then((res) => {
                vm.fourList = res.data;
                vm.fourList[0].homepageColBooks.list.forEach(item => {
                    vm.fourpkid.push(item.ebookId)
                })
                this.fourpkids = vm.fourpkid.join(",")
                // vm.fourids(this.fourpkids)
            });
        },
        fourids(fourpkids) {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                pkids: fourpkids,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
            };
            ids(obj).then((res) => {
                if(res.code == '200') {
                    vm.fourimageArr = res.data.list;
                    // let length = vm.fourimageArr.length;
                    let Base64 = require('js-base64').Base64
                    vm.fourimageArr.map((item) => {
                        
                        vm.bibGid = item.bibGid
                        if(item.coverImage == null) {
                            item.coverImage = vm.pic
                        } else {
                            item.coverImage = Base64.decode(item.coverImage);
                        }
                        
                    }) 
                }
            })
        },
        // 周排行
        byweek() {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
                pageNum: 1,
                pageSize: 8,
                orgId: userInfo.orgId,
            };
            byweek(obj).then((res) => {
                vm.byweekList = res.data.list;
                vm.byweekList.forEach(item => {
                    vm.weekpkid.push(item.ebookId);
                });
                this.weekpkids = vm.weekpkid.join(",")
                vm.byweekList[0].active = true;
                vm.weekids(this.weekpkids)
            });
        },
        weekids(weekpkids) {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                // tpkids: weekpkids,//贺州职业技术学院
                pkids: weekpkids,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
            };
            ids(obj).then((res) => {
                vm.weekArr = res.data.list;
                vm.weekArr.forEach(item => {
                    // item.active = false
                    vm.$set(item, 'active', false);
                });
                vm.weekArr[0].active = true;
                let Base64 = require('js-base64').Base64
                vm.weekArr.map((item) => {
                    vm.bibGid = item.bibGid
                    if(item.coverImage == null) {
                        item.coverImage = vm.pic
                    } else {
                        item.coverImage = Base64.decode(item.coverImage);
                    }
                })
            })
        },
        week() {
            this.byweeks = true;
            this.bymonths = false;
            this.byweek();
        },
        // 月排行
        bymonth() {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
                pageNum: 1,
                pageSize: 8,
                orgId: userInfo.orgId,
            };
            bymonth(obj).then((res) => {
                vm.bymonthList = res.data.list;
                vm.bymonthList.forEach(item => {
                    vm.monthpkid.push(item.ebookId)
                    item.active = false;
                })
                this.monthpkids = vm.monthpkid.join(",")
                vm.monthids(this.monthpkids)
            });
        },
        monthids(monthpkids) {
            let userInfo = getUserInfo();
            let vm = this,
            obj = {
                // tpkids: monthpkids,//贺州职业技术学院
                pkids: monthpkids,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
            };
            ids(obj).then((res) => {
                vm.monthArr = res.data.list;
                vm.monthArr.forEach(item => {
                    item.active = false
                })
                vm.monthArr[0].active = true;
                let Base64 = require('js-base64').Base64
                vm.monthArr.map((item) => {
                    vm.bibGid = item.bibGid
                    if(item.coverImage == null) {
                        item.coverImage = vm.pic
                    } else {
                        item.coverImage = Base64.decode(item.coverImage);
                    }
                })
            })
        },
        month() {
            this.byweeks = false;
            this.bymonths = true;
            this.bymonth();
        },
        //立即阅读
        read(item) {
            let userInfo = getUserInfo();
            let vm = this;
            if(item.classifyCode != null) {
                vm.classifyCode = item.classifyCode.slice(0,1)
            }
            var obj = {
                "creatorId": localStorage.userId,
                "source": item.source,
                "ebookId": item.pkid,
                "deviceType": 1,
                "actionType": 4,
                "visitType": 2,
                "publisherName": item.pubName,
                "subjectCode": item.parentSubjectCode,
                "classifyCode": vm.classifyCode,
                "visitUrl": location.href,
                "visitFunc": "",
                "logAccount": userInfo.account,
            }
            addId(obj).then((res) => {
                // this.fangfa.quanjutiaozhuan(item.fileType, item.pkid)
                if(item.source == 1) {
                    vm.fangfa.quanjutiaozhuan(item.fileType, item.pkid)
                } else {
                    let readUrl = item.readUrl;
                    // if(item.source == 2){
                    //     if(window.location.href.indexOf('172.16.58.158') > -1){   //学校内网
                    //         readUrl = readUrl.replace(/tsg.gxhzvc.cn/, '172.16.58.157:8081');
                    //     }
                    // }
                    window.open(readUrl);
                }
            }).catch(err=>{
            });
        },
        toDetail(item){
            let vm = this;
            const loading = vm.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.5)'
            });
            sourceType({
                pkid: item.ebookId,
                visitType: 1,
                visitUrl: window.location.href,
                visitFunc: '',
            }).then(res=>{
                if(res.status){
                    if(item.pageUrl){
                        window.open(item.pageUrl, '_blank');
                    }else{
                        let obj = {
                            pkid: item.ebookId,
                            source: res.data.list[0].source
                        }
                        vm.goBookDetails(obj);
                    }
                }
                loading.close();
            }).catch(err => {
                loading.close();
            });
        },
        // 跳转详情页
        goBookDetails(item) {
            let routeData = this.$router.resolve({path:"/home/bookDetails", query:{pkid: item.pkid, source:item.source}});
            window.open(routeData.href, '_blank');
            // if(item.source == 1) {
            //     let routeData = this.$router.resolve({path:"/home/bookDetails",query:{pkid: item.pkid}})
            //     window.open(routeData.href, '_blank');
            // } else {
            //     window.open(item.readUrl)
            // }
        },
    },
    
};
</script>

<style lang="scss" scoped>
.homePage {
    border-top: 3px solid #3daca5;
    .tab_color {
        color: #ff7f00;
    }
    .headerNav {
        height: 113px;
        width: 100%;
        background: url("../assets//images/bg.jpg") repeat-x center bottom;
        .wrap {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 auto;
            .headerNavLeft {
                a {
                    padding-right: 20px;
                    font-size: 17px;
                    cursor: pointer;
                    text-decoration: none;
                }
            }
            .headerNavRight {
                .el-input {
                    border: 2px solid #ccc;
                    border-radius: 5px;
                    ::v-deep.el-input .el-input__inner {
                        border: 0;
                    }
                }
                span {
                    margin-left: 20px;
                }
            }
        }
    }

    .container {
        position: relative;
        height: 358px;
        width: 850px;
        margin-left: 350px;
        .swiperimg {
            float: left;
            width: 850px;
            height: 358px;
            cursor: pointer;
            .img {
                height: 358px;
                width: 850px;
                background-repeat: no-repeat;
            }
        }
        .swiper-button-prev {
            position: absolute;
            width: 30px;
            height: 30px;
            background-color: aquamarine;
        }
        .el-carousel__item h3 {
            color: #475669;
            font-size: 14px;
            opacity: 0.75;
            line-height: 200px;
            margin: 0;
            height: 320px;
            width: 100%;
        }
        .el-carousel__item:nth-child(2n) {
            background-color: #99a9bf;
        }
        .el-carousel__item:nth-child(2n+1) {
            background-color: #d3dce6;
        }

        .img {
            width: 100%;
            height: 100%;
        }
    }

}
.el-carousel__item--card {
    width: 80%;
    left: -15%;
}
</style>


// WEBPACK FOOTER //
// src/views/HomePage.vue